export default __webpack_public_path__ + "c21ac6792bff9ebc55a3d32c1c68d316.woff";